/**
 * El color de marca del proyecto puede ser cualquiera (también uno claro, como un amarillo): el texto que va
 * encima y los enlaces de ese color se eligen para que se lean (contraste WCAG).
 */

function rgb(hex: string): [number, number, number] | null {
  const m = /^#?([0-9a-f]{6}|[0-9a-f]{3})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1]!.length === 3 ? [...m[1]!].map((c) => c + c).join("") : m[1]!;
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16)) as [number, number, number];
}

function luminance([r, g, b]: [number, number, number]): number {
  const lin = (v: number) => {
    const c = v / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
}

const contrast = (a: number, b: number) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
const INK = "#1a1817";
const INK_L = luminance([0x1a, 0x18, 0x17]);

/** El texto sobre el color de marca: blanco o tinta, el que más se lea. */
export function onAccent(hex: string): string {
  const c = rgb(hex);
  if (!c) return "#fff";
  const l = luminance(c);
  return contrast(l, 1) >= contrast(l, INK_L) ? "#fff" : INK;
}

/** El color de marca para texto sobre blanco (enlaces): se oscurece hasta llegar a 4,5:1. */
export function accentText(hex: string): string {
  const c = rgb(hex);
  if (!c) return hex;
  for (let k = 0; k <= 1; k += 0.05) {
    const d = c.map((v) => Math.round(v * (1 - k))) as [number, number, number];
    if (contrast(luminance(d), 1) >= 4.5) return `#${d.map((v) => v.toString(16).padStart(2, "0")).join("")}`;
  }
  return INK;
}
